export interface ReportCriteriaDTO {
  id?: number;
  idsIn?: number[];
  reportIdsIn?: number[];
  reportNumbersIn?: string[];
  reportNumberLike?: string;
  nameLike?: string;
  detailsLike?: string;
  enabled?: boolean;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
  reportUpdatedAtFrom?: string;
  reportUpdatedAtTo?: string;
  createdActorId?: string;
  sourceLike?: string;
  originalReportNameLike?: string;
  createFilterSet?: boolean;
  tagNameLike?: string;
  tagNamesIn?: string[];
  isPrivate?: boolean;
  favorited?: boolean;
  hasEmailSchedules?: boolean;
}

export const defaultReportCriteria: ReportCriteriaDTO = {
  tagNamesIn: [],
  isPrivate: false,
  enabled: true,
};
